<template>
    <el-dialog
        :model-value="props.visible"
        title="免税、减计收入、加计扣除类型选项表"
        width="1000"
        top="6vh"
        destroy-on-close
        :close-on-click-modal="false"
        @open="onOpen"
        @closed="closedModal"
    >
        <div v-loading="pageLoading">
            <div class="my-tax-enter-sub-table-wrap">
                <table>
                    <tbody>
                    <tr class="title-row">
                        <td>序号</td>
                        <td>选择</td>
                        <td>代码</td>
                        <td colspan="2">优惠事项</td>
                        <td>本年累计金额</td>
                    </tr>

                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[0].t_xh">1</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR00010'].checked"
                                :disabled="tableData['MSSR00010'].value != 0"
                                label=""
                                size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[0].yhswsx">MSSR00010</td>
                        <td class="title01" rowspan="11">免税收入</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[0].ewbhgjz">
                            国债利息收入免征企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number
                                v-model.trim="tableData['MSSR00010'].value" :controls="false"
                                :precision="2" :step="0.01"
                                style="width: 130px;"
                                :value-on-clear="0.0"
                                @change="tableData['MSSR00010'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr class="">
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[1].t_xh">2</td>
                        <td class="title01 center read" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR00021'].checked"
                                :disabled="tableData['MSSR00021'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[1].yhswsx">MSSR00021</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[1].ewbhgjz">
                            一般股息红利等权益性投资收益免征企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['MSSR00021'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['MSSR00021'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[2].t_xh">3</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR00022'].checked"
                                :disabled="tableData['MSSR00022'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[2].yhswsx">MSSR00022</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[2].ewbhgjz">
                            通过沪港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['MSSR00022'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['MSSR00022'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[3].t_xh">4</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR00023'].checked"
                                :disabled="tableData['MSSR00023'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[3].yhswsx">MSSR00023</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[3].ewbhgjz">
                            通过深港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['MSSR00023'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['MSSR00023'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[4].t_xh">5</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR00024'].checked"
                                :disabled="tableData['MSSR00024'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[4].yhswsx">MSSR00024</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[4].ewbhgjz">
                            持有创新企业CDR取得的股息红利所得免征企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['MSSR00024'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['MSSR00024'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[5].t_xh">6</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR00025'].checked"
                                :disabled="tableData['MSSR00025'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[5].yhswsx">MSSR00025</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[5].ewbhgjz">
                            永续债利息收入免征企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['MSSR00025'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['MSSR00025'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[6].t_xh">7</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR00030'].checked"
                                :disabled="tableData['MSSR00030'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[6].yhswsx">MSSR00030</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[6].ewbhgjz">
                            符合条件的非营利组织的收入免征企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['MSSR00030'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['MSSR00030'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[7].t_xh">8</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR00040'].checked"
                                :disabled="tableData['MSSR00040'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[7].yhswsx">MSSR00040</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[7].ewbhgjz">
                            投资者从证券投资基金分配中取得的收入免征企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['MSSR00040'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['MSSR00040'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[8].t_xh">9</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR00050'].checked"
                                :disabled="tableData['MSSR00050'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[8].yhswsx">MSSR00050</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[8].ewbhgjz">
                            取得的地方政府债券利息收入免征企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['MSSR00050'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['MSSR00050'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[29].t_xh">10</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR00100'].checked"
                                :disabled="tableData['MSSR00100'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[29].yhswsx">MSSR00100</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[29].ewbhgjz">
                            取得的基础研究收入免征企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['MSSR00100'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['MSSR00100'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[19].t_xh">11</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['MSSR99999'].checked"
                                :disabled="tableData['MSSR99999'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[19].yhswsx">MSSR99999</td>
                        <td class="title01 edit" isbinded="true">
                            <div style="display: flex;align-items: center;">
                                <span>其他：免税收入类未列明优惠</span>
                                （减免税代码：
                                <div class="div-in-td">
                                    <el-input-number
                                        class="left-number-input"
                                        style="width: 120px;"
                                        v-model.trim="tableData['MSSR99999'].disCode" :controls="false"
                                        :step="0.01"
                                        :value-on-clear="0.0"/>
                                </div>
                                ）
                            </div>
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['MSSR99999'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['MSSR99999'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[14].t_xh">12</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JJSR00010'].checked"
                                :disabled="tableData['JJSR00010'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[14].yhswsx">JJSR00010</td>
                        <td class="title01" rowspan="4">减计收入</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[14].ewbhgjz">
                            取得铁路债券利息收入减半征收企业所得税
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['JJSR00010'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['JJSR00010'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[15].t_xh">13</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JJSR00020'].checked"
                                :disabled="tableData['JJSR00020'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[15].yhswsx">JJSR00020</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[15].ewbhgjz">
                            取得的社区家庭服务收入在计算应纳税所得额时减计收入
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['JJSR00020'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['JJSR00020'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[16].t_xh">14</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JJSR00030'].checked"
                                :disabled="tableData['JJSR00030'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[16].yhswsx">JJSR00030</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[16].ewbhgjz">
                            综合利用资源生产产品取得的收入在计算应纳税所得额时减计收入
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['JJSR00030'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['JJSR00030'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[20].t_xh">15</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JJSR99999'].checked"
                                :disabled="tableData['JJSR99999'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[20].yhswsx">JJSR99999</td>
                        <td class="title01 edit" isbinded="true">
                            <div style="display: flex;align-items: center;">
                                <span>其他：减计收入类未列明优惠</span>
                                （减免税代码：
                                <div class="div-in-td">
                                    <el-input-number
                                        class="left-number-input"
                                        style="width: 120px;"
                                        v-model.trim="tableData['JJSR99999'].disCode"
                                        :controls="false"
                                        :step="0.01"
                                        :value-on-clear="0.0"/>
                                </div>
                                ）
                            </div>
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['JJSR99999'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['JJSR99999'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr ng-show="mssrGridlbVisible[31]()" class="">
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[31].t_xh">16</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JJKC00014'].checked"
                                :disabled="tableData['JJKC00014'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[31].yhswsx">JJKC00014</td>
                        <!-- ngIf: jjkcRowspan.jjkcRowspanDisplay === 'JJKC00014Rowspan' -->
                        <td ng-if="jjkcRowspan.jjkcRowspanDisplay === 'JJKC00014Rowspan'" class="title01 ng-scope"
                            rowspan="5">
                            加计扣除
                        </td><!-- end ngIf: jjkcRowspan.jjkcRowspanDisplay === 'JJKC00014Rowspan' -->
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[31].ewbhgjz">
                            企业开发新技术、新产品、新工艺发生的研究开发费用加计扣除（集成电路和工业母机企业按120%加计扣除）
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['JJKC00014'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['JJKC00014'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr ng-show="mssrGridlbVisible[33]()" class="">
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[33].t_xh">17</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JJKC00015'].checked"
                                :disabled="tableData['JJKC00015'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[33].yhswsx">JJKC00015</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[33].ewbhgjz">
                            企业开发新技术、新产品、新工艺发生的研究开发费用加计扣除（按100%加计扣除）
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['JJKC00015'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['JJKC00015'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr ng-show="mssrGridlbVisible[32]()" class="">
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[32].t_xh">18</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JJKC00024'].checked"
                                :disabled="tableData['JJKC00024'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[32].yhswsx">JJKC00024</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[32].ewbhgjz">
                            企业为获得创新性、创意性、突破性的产品进行创意设计活动发生的相关费用加计扣除（集成电路和工业母机企业按120%加计扣除）
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['JJKC00024'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['JJKC00024'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr ng-show="mssrGridlbVisible[34]()" class="">
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[34].t_xh">19</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JJKC00025'].checked"
                                :disabled="tableData['JJKC00025'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[34].yhswsx">JJKC00025</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[34].ewbhgjz">
                            企业为获得创新性、创意性、突破性的产品进行创意设计活动发生的相关费用加计扣除（按100%加计扣除）
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['JJKC00025'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['JJKC00025'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr ng-show="mssrGridlbVisible[28]()" class="">
                        <td class="title01 center ng-binding" ng-bind="mssrGrid.mssrGridlb[28].t_xh">20</td>
                        <td class="title01 center edit" isbinded="true">
                            <el-checkbox
                                v-model="tableData['JJKC00031'].checked"
                                :disabled="tableData['JJKC00031'].value != 0"
                                label="" size="large"/>
                        </td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[28].yhswsx">JJKC00031</td>
                        <td class="title01 ng-binding" ng-bind="mssrGrid.mssrGridlb[28].ewbhgjz">
                            企业投入基础研究支出加计扣除（按100%加计扣除）
                        </td>
                        <td class="edit right" isbinded="true">
                            <el-input-number v-model.trim="tableData['JJKC00031'].value" :controls="false"
                                             :precision="2" :step="0.01"
                                             style="width: 130px;"
                                             :value-on-clear="0.0"
                                             @change="tableData['JJKC00031'].checked = true"
                            />
                        </td>
                    </tr>
                    <tr ng-render-finish="" class="render-finish ng-isolate-scope"></tr>
                    </tbody>
                </table>
            </div>

            <div class="my-footer">
                <el-button
                    type="primary"
                    @click="onConfirm">确定
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import {ElMessage, ElMessageBox} from "element-plus";
import {cloneDeep} from "lodash";
import Big from "big.js";

const props = defineProps({
    visible: {
        type: Boolean,
        required: true
    },
    currentData: {
        type: Object,
        default: () => {
        }
    }
})

const initialData = {
    'MSSR00010': {
        name: '国债利息收入免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'MSSR00021': {
        name: '一般股息红利等权益性投资收益免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'MSSR00022': {
        name: '通过沪港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'MSSR00023': {
        name: '通过深港通投资且连续持有H股满12个月取得的股息红利所得免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'MSSR00024': {
        name: '持有创新企业CDR取得的股息红利所得免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'MSSR00025': {
        name: '永续债利息收入免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'MSSR00030': {
        name: '符合条件的非营利组织的收入免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'MSSR00040': {
        name: '投资者从证券投资基金分配中取得的收入免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'MSSR00050': {
        name: '取得的地方政府债券利息收入免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'MSSR00100': {
        name: '取得的基础研究收入免征企业所得税',
        checked: false,
        value: 0.00,
    },
    'MSSR99999': {
        name: '其他：免税收入类未列明优惠',
        checked: false,
        value: 0.00,
        disCode: null,
    },
    'JJSR00010': {
        name: '取得铁路债券利息收入减半征收企业所得税',
        checked: false,
        value: 0.00,
    },
    'JJSR00020': {
        name: '取得的社区家庭服务收入在计算应纳税所得额时减计收入',
        checked: false,
        value: 0.00,
    },
    'JJSR00030': {
        name: '综合利用资源生产产品取得的收入在计算应纳税所得额时减计收入',
        checked: false,
        value: 0.00,
    },
    'JJSR99999': {
        name: '其他：减计收入类未列明优惠',
        checked: false,
        value: 0.00,
        disCode: null,
    },
    'JJKC00014': {
        name: '企业开发新技术、新产品、新工艺发生的研究开发费用加计扣除（集成电路和工业母机企业按120%加计扣除）',
        checked: false,
        value: 0.00,
    },
    'JJKC00015': {
        name: '企业开发新技术、新产品、新工艺发生的研究开发费用加计扣除（按100%加计扣除）',
        checked: false,
        value: 0.00,
    },
    'JJKC00024': {
        name: '企业为获得创新性、创意性、突破性的产品进行创意设计活动发生的相关费用加计扣除（集成电路和工业母机企业按120%加计扣除）',
        checked: false,
        value: 0.00,
    },
    'JJKC00025': {
        name: '企业为获得创新性、创意性、突破性的产品进行创意设计活动发生的相关费用加计扣除（按100%加计扣除）',
        checked: false,
        value: 0.00,
    },
    'JJKC00031': {
        name: '企业投入基础研究支出加计扣除（按100%加计扣除）',
        checked: false,
        value: 0.00,
    },
}

const pageLoading = ref(false)
const tableData = ref(cloneDeep(initialData))

function onOpen() {
    (props.currentData.subData || []).forEach(it => {
        tableData.value[it.key].value = it.value
        tableData.value[it.key].checked = it.checked
        if (it.disCode != null) {
            tableData.value[it.key].disCode = it.disCode
        }
    })
}

function onConfirm() {
    const resData = []
    let total = new Big(0) // 合计

    Object.keys(tableData.value).forEach(key => {
        if (tableData.value[key].checked) {
            resData.push({
                key,
                ...tableData.value[key],
            })
            total = total.plus(tableData.value[key].value)
        }
    })
    emit('update:visible', false)
    emit('onConfirm', resData, total.toNumber())
}

const emit = defineEmits(['update:visible', 'onConfirm'])

function closedModal() {
    emit('update:visible', false)
    tableData.value = cloneDeep(initialData)
}
</script>

<style scoped lang="scss">
.my-footer {
    display: flex;
    flex-direction: row-reverse;
    margin-top: 30px;
}

.my-tax-enter-sub-table-wrap {
    max-height: calc(80vh - 100px);
    overflow-y: auto;
    padding-right: 10px;
    padding-bottom: 3px;

    &::-webkit-scrollbar {
        width: 5px;
    }

    &::-webkit-scrollbar-track {
        background-color: transparent;
    }

    &::-webkit-scrollbar-track-piece {
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(211, 211, 211, 0.9);
        border-radius: 10px;
    }

    > table {
        border: 1px solid #dcdcdc;
        border-collapse: collapse;

        tr {
            td {
                background-color: #fafafa;
                border: 1px solid #dcdcdc;
                padding: 10px 16px;

                &:nth-child(1) {
                    text-align: center;
                    width: 70px;
                }

                &:nth-child(2) {
                    width: 70px;
                    text-align: center;
                }

                &:nth-child(3) {
                    width: 120px;
                    text-align: center;
                }

                &:last-child {
                    width: 160px;
                    max-width: 160px;
                }
            }

            &.title-row {
                text-align: center;

                td {
                    font-weight: 700;
                }
            }
        }
    }
}

:deep(.left-number-input) {
    &.el-input-number .el-input__inner {
        text-align: left;
    }
}
</style>
